/**
 * Broker client-protection client (DEV-3783, Skynet.Accounts).
 * GET /api/brokerClientProtection returns the active "client protection" /
 * no-solicitation policy the authenticated broker should see, scoped server-side
 * to the caller's company. Returns 204 (no body) until a policy is published.
 *
 * Response shape (200):
 *   { body, effectiveDate, reportChannelEmail, updatedAt }
 */
export class BrokerClientProtectionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getClientProtection({ config = {} } = {}) {
    return this.#http.get('/api/brokerClientProtection', config);
  }
}
